import React, { useEffect, useState } from 'react'
import { Typography, LinearProgress, makeStyles, Theme, createStyles, Paper, TextField, useTheme, useMediaQuery } from '@material-ui/core'
import Constants, { breakpoint } from '../../types/constants';
import { IGlobalState, InEditingMode } from '../../states/GlobalState';
import { Formik, FormikProps, Form, Field } from 'formik'
import { useGlobal, useDispatch } from 'reactn'
import { useHistory } from 'react-router-dom'
import { WhatsNew } from '../../models/whatsNew';
import { UamTextField } from '../../formik/UamTextField';
import { WhatsNewServiceValidation } from '../../core/whatsNew/whatsNewFunctions';
import Auth, {getLevels} from '../../types/auth';
import { updateWhatsNew } from '../../services/whatsNewServices';
import { useLogger } from '../../logger';
import ErrorSummary from '../../formik/ErrorSummary';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
// import TextEditor from '../../richTextEditor/textEditor';
// import RichTextEditor from '../../richTextEditor/richTextEditor';
import EditorField from '../../richTextEditor/editorField';
import moment from 'moment';

const contentMaxWidth = Constants.PageEditWhatsNewContentMaxWidth;
const useStyles = makeStyles((theme: Theme) => createStyles({
    root: {
        overflow: 'auto',
        marginTop: theme.spacing(2),
    },
    error: {
        color: theme.palette.secondary.main,
    },
    fieldContainer: {
        width: contentMaxWidth,
        padding: 10,
        marginBottom: 20,
    },
    passwContainer: {
        padding: 10,
        marginBottom: 0,
        marginTop: 10,
    },
    disflex: {
        display: 'flex',
    },
    id: {

    }
}))

const formTextFieldMargin = 'dense'
export type SaveDataType = {
    values: any[]
}
type WhatsNewFieldsPropsType = {
    onLockedChange?: (isLocked: boolean) => void,
    onModifiedChange?: (isModified: boolean) => void,
    setSubmitCallback?: (callback: () => Promise<any>) => void,
    setRefreshCallback?: (callback: () => void) => void,
    onSubmit?: () => void,
}

export default function WhatsNewFields(props: WhatsNewFieldsPropsType) {
    const theme = useTheme();
    const [currentEditWhatsNewStatus,] = useGlobal<IGlobalState, 'currentEditWhatsNewStatus'>('currentEditWhatsNewStatus');
    const [currentEditWhatsNew,] = useGlobal<IGlobalState, 'currentEditWhatsNew'>('currentEditWhatsNew');
    const [auth] = useGlobal<IGlobalState, 'auth'>('auth');
    const [ip] = useGlobal<IGlobalState, 'ip'>('ip');
    const classes = useStyles();
    const mobile = useMediaQuery(theme.breakpoints.down(breakpoint));

    // const [promptDialogProps, setPromptDialogProps] = useState<PromptDialogType>({ open: false })
    // const [editorState, setEditorState] = useState(() => EditorState.createEmpty());
    const adLevels = getLevels(auth.authData);
    const [whatsNewService] = useState(() => new WhatsNewServiceValidation(adLevels))
    const dispatch = useDispatch();
    const history = useHistory();
    const logger = useLogger({key: 'whatsNewFields'});
    const whatsNewFormSchema = whatsNewService.whatsNewFormSchemaBase();
    let width = mobile ? 'auto' : contentMaxWidth;
    // TODO SET APPLICATION
    return (
        <div className={classes.root}>
            <Formik
                initialValues={{...currentEditWhatsNew!.whatsNew as WhatsNew }}
                validationSchema={whatsNewFormSchema}
                // validateOnMount={true}
                validateOnChange={true}
                onSubmit={(values, { setSubmitting }) => {
                    console.log(`*** +++ Formik.onSubmit ${currentEditWhatsNewStatus}`);
                    const updWhatsNew = whatsNewFormSchema.cast(values);
                    // A questo punto scegliamo se fare un'update o un add in base al valore di oid
                    // console.log('Sono in gestione eventi');
                    if (updWhatsNew!.Id > 0) {
                        /* TODO
                        */
                        // console.log('Sono in evento update whatsnew: ' + JSON.stringify(editorState));
                        // console.log('Sono in evento update whatsnew: ' + updWhatsNew.ExpirationDate);
                        // console.log('Sono in evento update whatsnew: ' + moment(updWhatsNew.ExpirationDate!).format('DD/MM/YYYY'));
                        // updWhatsNew.HtmlContent = editorState;
                        // if (values.ExpirationDate)
                        //     updWhatsNew.ExpirationDate = moment(values.ExpirationDate).format('YYYY-MM-DD');
                        updateWhatsNew(ip, auth.authData!, auth.user!, updWhatsNew).then(updatedWhatsNew => {
                            // console.log('WhatsNew updated', updatedWhatsNew)
                            // e qui dobbiamo sostituire l'utente in editing con quello modificato
                            if (updatedWhatsNew) {
                                //TODO
                                dispatch.whatsNewSaved(updatedWhatsNew);
                                logger.info(`WhatsNew ${updatedWhatsNew.Title} salvata!`);
                            } else {
                                logger.error('Problemi nel salvataggio della whatsNew');
                            }
                        }).catch(error => {
                            console.error('Error in saving WhatsNew');
                            logger.error(error, 'error');
                        }).finally(() => {
                            setSubmitting(false);
                            // props.onSubmit && props.onSubmit();
                        })
                    } else {
                        // console.log('Sono in add whatsNew');
                        /* TODO Add whatsNew
                        */
                        updWhatsNew.Id = 0;
                        updateWhatsNew(ip, auth.authData!, auth.user!, updWhatsNew).then(response => {
                            console.log('WhatsNew add', response)
                            if (response) {
                                if (response.Id > 0) {
                                    // e qui dobbiamo sostituire l'utente in editing con quello modificato
                                    //TODO, aggiornare lo stato
                                    console.log('whatsNew added is: ' + JSON.stringify(response))
                                    dispatch.newWhatsNewSaved(response.Id, response);
                                    values.Id = response.Id;
                                    values.InsertDate = response.InsertDate;

                                    logger.info('WhatsNew salvata correttamente');
                                } else {
                                    const message = `Errore nel salvataggio: `;
                                    logger.error(message, 'error');
                                }
                            }
                        }).finally(() => {
                            setSubmitting(false);
                            // props.onSubmit && props.onSubmit();
                        })
                    }
                }}
            >
                {(formprops: FormikProps<WhatsNew>) => {
                    const { isSubmitting, handleSubmit, values, dirty, submitForm, resetForm, isValid, errors, setFieldValue } = formprops
                    // eslint-disable-next-line react-hooks/rules-of-hooks
                    // useEffect(() => {
                    //     //TODO
                    //     if (dirty) {
                    //         if (currentEditWhatsNewStatus === 'Pristine') { setCurrentEditWhatsNewStatus('Modified') }
                    //     } else {
                    //         if (currentEditWhatsNewStatus === 'Modified') { setCurrentEditWhatsNewStatus('Pristine') }
                    //     }
                    // }, [dirty])
                    if (props.setSubmitCallback) {
                        console.log('Imposto la chiamata della submit di formik ');
                        props.setSubmitCallback(submitForm);
                    } 
                    if (props.setRefreshCallback) {
                        console.log('Imposto la chiamata della refresh di formik ');
                        props.setRefreshCallback(resetForm);
                    } 
                    
                    //TODO VERIFY
                    // const handleNavigationAttempt = (navigation: any, location: any, action: string) => {
                    //     console.log('handleNavigationAttempt', navigation, location, action)
                    //     setPromptDialogProps({
                    //         open: true,
                    //         cancel: () => { closeDialog(); navigation.cancel(); },
                    //         resume: () => {
                    //             closeDialog();
                    //             resetForm();
                    //             //TODO
                    //             setCurrentEditWhatsNewStatus('Pristine');
                    //             navigation.resume();
                    //         },
                    //     })
                    //     return null;
                    // }

                    return (
                        <Form onSubmit={handleSubmit} translate>
                            {/* <ReactRouterPause handler={handleNavigationAttempt} when={dirty} /> */}
                            {/* <ConfirmNavigation {...promptDialogProps} /> */}
                            <Paper className={classes.fieldContainer} style={{width: width}}>
                                <div className={classes.disflex}>
                                    <TextField label='Id' margin={formTextFieldMargin} value={values.Id} className={classes.id} fullWidth/>
                                    &nbsp;
                                    <TextField label='Data fine' margin={formTextFieldMargin} value={values.ExpirationDate} className={classes.id} fullWidth
                                        inputProps={{readOnly: true}}
                                    />
                                    {/*
                                    <Field as={KeyboardDatePicker} label='Data fine' name='ExpirationDate' 
                                        clearable={false} 
                                        // autoOk 
                                        format='DD/MM/YYYY' 
                                        fullWidth margin='dense' 
                                        inputProps={{readOnly: true}}                                                                                
                                        // value={values.Disabled} 
                                        // onChange={handleDisabledChanged} 
                                        // onChange={value => setFieldValue("ExpirationDate", moment(value).format('YYYY-MM-DD'))}
                                    />
                                    */}
                                </div>
                                <div className={classes.disflex}>
                                    <UamTextField label='Versione' name='Version' fullWidth margin={formTextFieldMargin} />
                                    &nbsp;
                                    <UamTextField label='Titolo' name='Title' fullWidth margin={formTextFieldMargin} />                                    
                                </div>
                                <div>
                                    <Field
                                        component={EditorField}
                                        name="HtmlContent"
                                        label="Write a news"
                                        placeholder="content here"
                                    />
                                </div>
                                {isSubmitting && <LinearProgress color='primary' />}
                            </Paper>
                            {!isValid && <ErrorSummary title='Errori da correggere' errors={errors} schema={whatsNewFormSchema} />}
                        </Form>
                        )
                    }
                }
            </Formik>
        </div>
    )
}


